import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaComponent } from './media.component';
import { MaterialModuleMobi } from '../material/material.module';
import { FormsModule } from '@angular/forms';
import { AppPermissionsPipe, SharedModule } from 'shared-library';



@NgModule({
  declarations: [MediaComponent],
  imports: [
    CommonModule,
    MaterialModuleMobi,FormsModule,
    SharedModule,
    AppPermissionsPipe
  ],
  exports:[
    MediaComponent,
  ]
})
export class MediaModule { }
